import { render, staticRenderFns } from "./ConsWorkplace.vue?vue&type=template&id=378d3289"
import script from "./ConsWorkplace.vue?vue&type=script&lang=js"
export * from "./ConsWorkplace.vue?vue&type=script&lang=js"
import style0 from "./ConsWorkplace.vue?vue&type=style&index=0&id=378d3289&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports